module.exports = __webpack_public_path__ + "static/media/view exam info.d85fa71a.svg";